import { css } from 'lit';

export default css`.fs-circular-loader {
  --fs-circular-loader-fill: currentColor;
  --fs-circular-loader-duration: 1.6s;

  /** Global */
  color: var(--fs-color-feedback-info-primary, hsl(200, 98%, 35%));
  height: 44px; /* Default loader size per spec */
  width: 44px /* Default loader size per spec */
}

.fs-circular-loader.fs-circular-loader--inherit-color {
    color: inherit;
  }

.fs-circular-loader.fs-circular-loader--medium {
    height: 22px;
    width: 22px;
  }

.fs-circular-loader.fs-circular-loader--small {
    height: 14px;
    width: 14px;
  }

.fs-circular-loader.fs-circular-loader--inverted {
    --fs-circular-loader-fill: var(--fs-color-background-white, hsl(0, 0%, 100%));
  }

.fs-circular-loader .fs-circular-loader__indicator {
    fill: var(--fs-color-constant-transparent, hsla(0, 0%, 0%, 0));
    stroke-width: 9;
    transform-origin: center;
  }

.fs-circular-loader.fs-circular-loader--small .fs-circular-loader__indicator {
      r: 44;
    }

.fs-circular-loader:not(.fs-circular-loader--indeterminate).fs-circular-loader--small .fs-circular-loader__indicator {
        stroke-width: 12;
      }

.fs-circular-loader:not(.fs-circular-loader--indeterminate) .fs-circular-loader__indicator {
      transform: rotate(-90deg);
      transition: stroke-dashoffset 0.5s var(--fs-animation-easing-purposeful-standard, cubic-bezier(0.30, 0.00, 0.00, 1.00));
      stroke: var(--fs-circular-loader-fill);
      /* stroke-dasharray: 288.889; */
      stroke-dasharray: 278.889;
      stroke-linecap: round;
      stroke-width: 9;
    }

.fs-circular-loader.fs-circular-loader--indeterminate {
    animation: var(--fs-circular-loader-duration) cubic-bezier(0.30, 0.00, 0.26, 1.00) infinite both fs-loader-animation
  }

.fs-circular-loader.fs-circular-loader--indeterminate .fs-circular-loader__indicator {
      animation: var(--fs-circular-loader-duration) infinite both fs-loader-circle-animation;
      stroke: var(--fs-circular-loader-fill);
      stroke-linecap: round;
      stroke-dasharray: 300;
    }

@media (prefers-reduced-motion) {

.fs-circular-loader.fs-circular-loader--indeterminate {
      --fs-circular-loader-duration: 2.4s
    
  }}

.fs-circular-loader.fs-circular-loader--inactive,
.fs-circular-loader__announcement {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0,0,0,0);
  border: 0;
}

@keyframes fs-loader-animation {
  5% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(445deg);
  }
}

@keyframes fs-loader-circle-animation {
  0% {
    stroke-dashoffset: 285;
    transform: rotate(270deg);
  }

  30% {
    stroke-dashoffset: 90;
    transform: rotate(270deg);
    animation: cubic-bezier(0.88, 0.15, 0.49, 0.83);
  }

  80%, 85% {
    stroke-dashoffset: 285;
    transform: rotate(540deg);
    animation: cubic-bezier(0.17, 0.17, 0.20, 1.00);
  }

  85%, 100% {
    stroke-dashoffset: 285;
    transform: rotate(540deg);
  }
}`;